var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    width: "100%",
                    "max-width": "800px",
                    elevation: "24"
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "", color: "primary-color" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(" Redefinir senha de eleitor ")
                      ]),
                      _c("v-spacer"),
                      _c("v-tooltip", { attrs: { right: "" } }, [void 0], 2)
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        { ref: "frmPRR" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "E-mail",
                              placeholder: "Informe o seu e-mail",
                              rules: _vm.requiredRules,
                              required: ""
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _c(
                            "v-card",
                            { attrs: { "max-width": "350px", elevation: "0" } },
                            [_c("ValidateRecaptcha", { ref: "validateR" })],
                            1
                          ),
                          _c(
                            "v-expand-transition",
                            [
                              _c(
                                "v-alert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.alert.show,
                                      expression: "alert.show"
                                    }
                                  ],
                                  staticClass: "mt-5",
                                  attrs: {
                                    elevation: "2",
                                    type: _vm.alert.typeAlert.value
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.alert.value) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.btnLoading,
                            disabled: _vm.btnLoading,
                            outlined: ""
                          },
                          on: { click: _vm.btnRequest }
                        },
                        [_vm._v(" Solicitar ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            disabled: _vm.btnLoading,
                            outlined: ""
                          },
                          on: { click: _vm.returnElection }
                        },
                        [_vm._v(" Cancelar ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }